import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '../../utils/cn'

const RotateDeviceNotification = () => {
  const { t } = useTranslation()
  const [imageLoaded, setImageLoaded] = useState<boolean>(false)

  const onLoadImage = () => {
    setImageLoaded(true)
  }

  const fadeClassName = cn('[transition:opacity_0.3s]', {
    'opacity-100': imageLoaded,
    'opacity-0': !imageLoaded,
  })

  return (
    <div className="absolute left-0 top-0 z-[1100] flex size-full flex-col items-center justify-center bg-white px-[10vw] py-0 text-center">
      <p className={cn('mb-[3em]', fadeClassName)}>{t('screenOrientationErrorMessage')}</p>
      <div
        className={cn('bg-center', fadeClassName, {
          'animate-quarter-turn bg-no-repeat': imageLoaded,
        })}
        // a root-relative url() in the Tailwind CSS would be resolved (and rejected) by webpack
        style={{ backgroundImage: "url('/icons/icon-rotation-arrow.png')" }}
      >
        <img className="w-full" src="/images/device.png" alt="" onLoad={onLoadImage} />
      </div>
      <p className={cn('mb-[3em]', fadeClassName)}>{t('screenOrientationErrorInstruction')}</p>
    </div>
  )
}

export default RotateDeviceNotification
